// extracted by mini-css-extract-plugin
module.exports = {"description":"PageDescription_description__46PiS"};